// Single source of truth for league_type values.
// These MUST match the values in the database (leagues.league_type).
// When the backend changes, change ONLY this file.

export const LEAGUE_TYPE = {
  TRADITIONAL: 'traditional',
  QUICK: 'quick',
} as const;

export type LeagueType = (typeof LEAGUE_TYPE)[keyof typeof LEAGUE_TYPE];

// Quick league types — used for Supabase .in() queries
export const QL_TYPES: readonly string[] = [LEAGUE_TYPE.QUICK];

// Traditional league types — used for Supabase .in() queries
export const TRAD_TYPES: readonly string[] = [LEAGUE_TYPE.TRADITIONAL];

// Legacy values accepted for backward compat (some old DB rows still have these)
export const LEGACY_REGULAR = 'regular';
export const LEGACY_FAST_1S = 'fast_1s';
export const LEGACY_FAST_5S = 'fast_5s';
export const LEGACY_FAST_12 = 'fast_12';
export const LEGACY_FAST_24 = 'fast_24';

// Ready-to-use arrays for Supabase .in() queries
export const QL_ARRAY: readonly string[] = [LEAGUE_TYPE.QUICK];
export const TRAD_ARRAY: readonly string[] = [LEAGUE_TYPE.TRADITIONAL, LEGACY_REGULAR];
